import {
  UpgradeAssessment,
  UpgradePlan,
  UpgradeStage,
  UpgradeTemplate,
} from 'api/models';
import {
  UPGRADE_ASSESSMENT_EKS_131,
  UPGRADE_ASSESSMENT_EKS_131_STAGES,
} from './upgrade_assessment_eks_131';
import {
  UPGRADE_ASSESSMENT_GKE_131,
  UPGRADE_ASSESSMENT_GKE_131_STAGES,
} from './upgrade_assessment_gke_131';
import {
  UPGRADE_TEMPLATE_ADDONS_CERT_MANAGER,
  UPGRADE_TEMPLATE_ADDONS_CERT_MANAGER_STAGES,
} from './upgrade_template_cert-manager';
import {
  UPGRADE_PLAN_ADDONS_CERT_MANAGER,
  UPGRADE_PLAN_ADDONS_CERT_MANAGER_STAGES,
} from './upgrade_plan_cert-manager';
import {
  UPGRADE_PLAN_CLUSTERS_EKS_131,
  UPGRADE_PLAN_CLUSTERS_EKS_131_STAGES,
} from './upgrade_clusters_eks_131';
import {
  UPGRADE_PLAN_CLUSTERS_GKE_131,
  UPGRADE_PLAN_CLUSTERS_GKE_131_STAGES,
} from './upgrade_clusters_gke_131';
import {
  UPGRADE_TEMPLATE_CLUSTERS_EKS_131,
  UPGRADE_TEMPLATE_CLUSTERS_EKS_131_STAGES,
} from './upgrade_template_eks_131';
import {
  UPGRADE_TEMPLATE_CLUSTERS_GKE_131,
  UPGRADE_TEMPLATE_CLUSTERS_GKE_131_STAGES,
} from './upgrade_template_gke_131';

export const UPGRADE_TEMPLATES: UpgradeTemplate[] = [
  UPGRADE_TEMPLATE_CLUSTERS_EKS_131,
  UPGRADE_TEMPLATE_CLUSTERS_GKE_131,
  {
    id: 'upgtmpl_ef7aff6e-aa2d-11ee-a506-0242ac120002',
    name: 'template-eks-129-usw1-prod-1.29-1.30',
    resources: { clusters: [{ id: 'id-eks-129-usw1-prod' }] },
    environment: 'Prod',
    current_version: '1.29',
    desired_version: '1.30',
    deployment_strategy: 'pick-for-me',
    status: 'approved',
    created: new Date(2025, 8, 8).getTime(),
    updated: new Date(2025, 8, 10).getTime(),
    last_validated: new Date(2025, 8, 10).getTime(),
    requested_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    owner: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    approved_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    status_comment:
      "The recommended upgrade steps look good, let's proceed with the upgrade.",
    approved: new Date(2025, 8, 11).getTime(),
  },
  {
    id: 'upgtmpl_1',
    environment: 'Dev',
    status: 'approved',
    name: 'template-gke-129-usw4-dev-1.29-1.30',
    current_version: '1.29',
    desired_version: '1.30',
    resources: { clusters: [{ id: 'id-gke-129-usw4-dev' }] },
    deployment_strategy: 'in-place',
    created: new Date(2025, 8, 4).getTime(),
    updated: new Date(2025, 8, 5).getTime(),
    last_validated: new Date(2025, 8, 5).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    approved_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    status_comment:
      "The recommended upgrade steps look good, let's proceed with the upgrade.",
    approved: new Date(2025, 8, 7).getTime(),
  },
  {
    id: 'upgtmpl_2',
    environment: 'Dev',
    status: 'in-progress',
    name: 'template-gke-132-nane1-dev-1.32',
    current_version: '1.32',
    desired_version: '1.33',
    resources: { clusters: [{ id: 'id-gke-132-nane1-sandbox' }] },
    deployment_strategy: 'in-place',
    created: new Date(2025, 9, 3).getTime(),
    updated: new Date(2025, 9, 8).getTime(),
    last_validated: new Date(2025, 9, 8).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
  },
  {
    id: 'upgtmpl_3',
    name: 'template-gke-131-nane1-dev-1.3-1.32',
    resources: { clusters: [{ id: 'id-gke-131-nane1-sandbox' }] },
    current_version: '1.31',
    desired_version: '1.32',
    deployment_strategy: 'in-place',
    environment: 'Dev',
    status: 'in-progress',
    created: new Date(2025, 9, 3).getTime(),
    updated: new Date(2025, 9, 7).getTime(),
    last_validated: new Date(2025, 9, 7).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
  },
  {
    id: 'upgtmpl_4',
    name: 'template-aks-131-eu2-staging-1.31-1.32',
    resources: { clusters: [{ id: 'id-aks-131-eu2-staging' }] },
    current_version: '1.31',
    desired_version: '1.32',
    deployment_strategy: 'in-place',
    environment: 'Staging',
    status: 'approved',
    created: new Date(2025, 9, 5).getTime(),
    updated: new Date(2025, 9, 10).getTime(),
    last_validated: new Date(2025, 9, 10).getTime(),
    requested_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    owner: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    approved_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    status_comment:
      "The recommended upgrade steps look good, let's proceed with the upgrade.",
    approved: new Date(2025, 9, 11).getTime(),
  },

  // Project Upgrade Templates
  UPGRADE_TEMPLATE_ADDONS_CERT_MANAGER,
  {
    id: 'upgtmpl_5',
    name: 'template-grafana-loki-v2.6.1',
    resources: {
      addon_instances: [
        {
          id: 'id-grafana-loki-upgrade-1',
        },
      ],
    },
    status: 'in-progress',
    current_version: 'v2.6.1',
    desired_version: 'v2.8.3',
    deployment_strategy: 'in-place',
    environment: 'Staging',
    created: new Date(2024, 1, 1).getTime(),
    updated: new Date(2024, 1, 8).getTime(),
    last_validated: new Date(2024, 1, 6).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
  },
  {
    id: 'upgtmpl_6',
    name: 'template-argocd-v2.5.1',
    resources: {
      addon_instances: [
        {
          id: 'id-argocd_upgrade-1',
        },
      ],
    },
    status: 'approved',
    current_version: 'v2.5.1',
    desired_version: 'v2.5.16',
    deployment_strategy: 'in-place',
    environment: 'Prod',
    created: new Date(2023, 11, 25).getTime(),
    updated: new Date(2024, 0, 21).getTime(),
    last_validated: new Date(2024, 0, 19).getTime(),
    requested_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    approved_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    approved: new Date(2024, 0, 21).getTime(),
  },
  {
    id: 'upgtmpl_7',
    name: 'template-prometheus-v0.63.0',
    resources: {
      addon_instances: [
        {
          id: 'id-prometheus-operator-upgrade-1',
        },
      ],
    },
    status: 'regenerate-in-progress',
    current_version: 'v0.63.0',
    desired_version: 'v0.66.0',
    deployment_strategy: 'in-place',
    environment: 'Dev',
    created: new Date(2023, 8, 27).getTime(),
    updated: new Date(2023, 9, 14).getTime(),
    last_validated: new Date(2023, 9, 12).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
  },
  {
    id: 'upgtmpl_8',
    name: 'template-nginx-oss-v1.14.2',
    resources: {
      addon_instances: [
        {
          id: 'addinst_nginx-oss-1',
        },
      ],
    },
    status: 'approved',
    current_version: 'v1.14.2',
    desired_version: 'v1.25.3',
    deployment_strategy: 'in-place',
    environment: 'Dev',
    created: new Date(2023, 8, 27).getTime(),
    updated: new Date(2023, 9, 14).getTime(),
    last_validated: new Date(2023, 9, 12).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    approved: new Date(2023, 9, 14).getTime(),
    approved_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
  },
];

export const UPGRADES: UpgradePlan[] = [
  /* Cluster Upgrades */
  UPGRADE_PLAN_CLUSTERS_EKS_131,
  UPGRADE_PLAN_CLUSTERS_GKE_131,
  {
    id: 'upgr_ef7aff6e-aa2d-11ee-a506-0242ac120002',
    name: 'plan-eks-131-usw1-prod-1.31-1.32',
    resources: { clusters: [{ id: 'id-eks-131-usw1-prod' }] },
    deployment_strategy: 'pick-for-me',
    status: 'completed',
    current_version: '1.31',
    desired_version: '1.32',
    created: new Date(2025, 11, 8).getTime(),
    updated: new Date(2025, 11, 9).getTime(),
    last_validated: new Date(2025, 11, 11).getTime(),
    upgrade_template_id: 'upgtmpl_ef7aff6e-aa2d-11ee-a506-0242ac120002',
    requested_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    owner: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    completed_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
  },
  {
    id: 'upgr_1',
    name: 'plan-eks-130-use2-staging-v1.30-v1.31',
    resources: {
      clusters: [{ id: 'id-eks-130-use2-staging' }],
    },
    deployment_strategy: 'in-place',
    status: 'completed',
    current_version: '1.30',
    desired_version: '1.31',
    created: new Date(2025, 7, 12).getTime(),
    updated: new Date(2025, 7, 14).getTime(),
    last_validated: new Date(2025, 7, 17).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    completed_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
  },
  {
    id: 'upgr_2',
    name: 'plan-gke-129-usw4-dev-v1.29-v1.30',
    resources: { clusters: [{ id: 'id-gke-129-usw4-dev' }] },
    deployment_strategy: 'blue-green',
    status: 'completed',
    current_version: 'v1.29',
    desired_version: 'v1.30',
    created: new Date(2025, 8, 6).getTime(),
    updated: new Date(2025, 8, 8).getTime(),
    last_validated: new Date(2025, 8, 7).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    completed_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
  },
  {
    id: 'upgr_3',
    name: 'plan-gke-132-nane1-dev-v1.32-v1.33',
    resources: { clusters: [{ id: 'id-gke-132-nane1-sandbox' }] },
    deployment_strategy: 'in-place',
    status: 'completed',
    current_version: '1.32',
    desired_version: '1.33',
    created: new Date(2025, 9, 8).getTime(),
    updated: new Date(2025, 9, 10).getTime(),
    last_validated: new Date(2025, 9, 9).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: '',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    completed_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
  },
  {
    id: 'upgr_4',
    name: 'plan-aks-129-eu2-staging-v1.29-v1.30',
    resources: { clusters: [{ id: 'id-aks-129-eu2-staging' }] },
    deployment_strategy: 'in-place',
    current_version: 'v1.29',
    desired_version: 'v1.30',
    status: 'completed',
    created: new Date(2025, 9, 12).getTime(),
    updated: new Date(2025, 9, 18).getTime(),
    last_validated: new Date(2025, 9, 15).getTime(),
    requested_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    completed_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
  },

  /* Addon Upgrades */
  UPGRADE_PLAN_ADDONS_CERT_MANAGER,
  {
    id: 'upgr_3b8e2ac2-ef15-4b06-bc75-df1731645b3e',
    name: 'plan-prometheus-operator-v0.63.0-v0.66.0',
    resources: {
      addon_instances: [
        {
          id: 'addinst_prometheus-operator-1',
        },
      ],
    },
    current_version: 'v0.63.0',
    desired_version: 'v0.66.0',
    deployment_strategy: 'in-place',
    status: 'completed',
    created: new Date(2023, 8, 27).getTime(),
    updated: new Date(2023, 9, 14).getTime(),
    last_validated: new Date(2023, 9, 12).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    completed_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
  },
  {
    id: 'upgr_e9e674d1-6ad5-4a47-a300-6b3f515179f5',
    name: 'plan-grafana-loki-v2.6.1-v2.8.3',
    resources: {
      addon_instances: [
        {
          id: 'addinst_grafana-loki-1',
        },
      ],
    },
    deployment_strategy: 'in-place',
    current_version: 'v2.6.1',
    desired_version: 'v2.8.3',
    status: 'completed',
    created: new Date(2024, 1, 1).getTime(),
    updated: new Date(2024, 1, 8).getTime(),
    last_validated: new Date(2024, 1, 6).getTime(),
    requested_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    completed_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
  },
  {
    id: 'upgr_e9e674d1-6ad5-4a47-a300-6b3f515179f3',
    name: 'plan-argocd-v2.5.1-to-v2.5.16',
    resources: {
      addon_instances: [
        {
          id: 'addinst_argocd-1',
        },
      ],
    },
    deployment_strategy: 'in-place',
    current_version: 'v2.5.1',
    desired_version: 'v2.5.16',
    status: 'completed',
    created: new Date(2023, 11, 25).getTime(),
    updated: new Date(2024, 0, 21).getTime(),
    last_validated: new Date(2024, 0, 19).getTime(),
    requested_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    completed_by: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
  },
  {
    id: 'upgr_3',
    name: 'plan-nginx-v1.14.2-v1.25.3',
    resources: {
      addon_instances: [
        {
          id: 'addinst_nginx-oss-1',
        },
      ],
    },
    status: 'completed',
    current_version: 'v1.14.2',
    desired_version: 'v1.25.3',
    deployment_strategy: 'in-place',
    created: new Date(2024, 1, 5).getTime(),
    updated: new Date(2024, 1, 9).getTime(),
    last_validated: new Date(2024, 1, 8).getTime(),
    requested_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    owner: {
      email: 'roger@chkk.io',
      id: 'usr_w12123',
      name: 'Roger Walter',
      picture: '',
    },
    completed_by: {
      email: 'katy@chkk.io',
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
  },
];

export const UPGRADE_STAGES = new Map<string, UpgradeStage[]>([
  [
    UPGRADE_TEMPLATE_CLUSTERS_EKS_131.id,
    UPGRADE_TEMPLATE_CLUSTERS_EKS_131_STAGES,
  ],
  [
    UPGRADE_TEMPLATE_CLUSTERS_GKE_131.id,
    UPGRADE_TEMPLATE_CLUSTERS_GKE_131_STAGES,
  ],
  [
    UPGRADE_TEMPLATE_ADDONS_CERT_MANAGER.id,
    UPGRADE_TEMPLATE_ADDONS_CERT_MANAGER_STAGES,
  ],

  [
    UPGRADE_PLAN_ADDONS_CERT_MANAGER.id,
    UPGRADE_PLAN_ADDONS_CERT_MANAGER_STAGES,
  ],
  [UPGRADE_PLAN_CLUSTERS_EKS_131.id, UPGRADE_PLAN_CLUSTERS_EKS_131_STAGES],
  [UPGRADE_PLAN_CLUSTERS_GKE_131.id, UPGRADE_PLAN_CLUSTERS_GKE_131_STAGES],

  [UPGRADE_ASSESSMENT_EKS_131.id, UPGRADE_ASSESSMENT_EKS_131_STAGES],
  [UPGRADE_ASSESSMENT_GKE_131.id, UPGRADE_ASSESSMENT_GKE_131_STAGES],
]);

export const UPGRADE_ASSESSMENTS: UpgradeAssessment[] = [
  UPGRADE_ASSESSMENT_EKS_131,
  UPGRADE_ASSESSMENT_GKE_131,
  {
    id: 'upgrasses_2e6323a4-576b-4d32-99da-70204ee00982',
    name: 'assesment-eks-130-use2-prod-1.30-1.32',
    status: 'pending',
    deployment_strategy: 'in-place',
    environment: 'prod',
    current_version: '1.30',
    desired_version: '1.32',
    resources: { clusters: [{ id: 'id-eks-130-usw1-prod' }] },
    requested_by: {
      id: 'usr_w12123',
      name: 'Katy Smith',
      picture: '',
    },
    created: 1747505992000,
  },
];

export function isExampleData(id: string): boolean {
  if (UPGRADES.map((upgr) => upgr.id).indexOf(id) !== -1) {
    return true;
  }
  if (UPGRADE_TEMPLATES.map((upgr) => upgr.id).indexOf(id) !== -1) {
    return true;
  }
  if (UPGRADE_ASSESSMENTS.map((upgr) => upgr.id).indexOf(id) !== -1) {
    return true;
  }
  return false;
}
